/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-02 14:25:56
 * @LastEditors  : Zhelin Cheng
 * @LastEditTime : 2021-05-02 16:45:47
 * @FilePath     : /marketing-landing-fe/src/utils/eventemitter.ts
 * @Description  : 未添加文件描述
 */
import EventEmitter from 'eventemitter3';
export default new EventEmitter();